import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import App from './components/App'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Provider } from 'react-redux'
import store from './store'
import AllScanContext from './components/ContextApi'
import ErrorBoundary from './utils/ErrorBoundary'

const theme = createTheme()

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <AllScanContext>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        {/* <BrowserRouter> */}
        <HashRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </HashRouter>
        {/* </BrowserRouter> */}
      </ThemeProvider>
    </Provider>
  </AllScanContext>,
  // </React.StrictMode>,
  document.getElementById('root')
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('✅ Service Worker registered:', reg.scope)
      })
      .catch((err) => {
        console.error('❌ Service Worker registration failed:', err)
      })
  })
}
